import { useMutation } from "react-query";
import servicesUtils from "../../../utils/servicesUtils";

const useAddCondition = () => {
  return useMutation(({params, workspaceId}) => servicesUtils.postService(`/workspaces/${workspaceId}/routing/`, params));
};

export default useAddCondition;
